import { Link, useNavigate } from "react-router-dom";
import { Button, Card, Space, Tag, Typography } from "antd";
import { ArrowRight, Check, Plane, Zap } from "lucide-react";
import { stats } from "../landingData";

const { Title, Paragraph, Text } = Typography;


//hookup figma make to claude code and this to claude code and try to get it to carry over the style
//but match our stack

export function HeroSection() {
  const navigate = useNavigate();

  return (
    <>
      <header className="landing-header">
        <Link to="/" className="landing-logo">
          <Plane size={24} className="landing-logo-icon" />
          <span>Hairplane</span>
        </Link>

        <Space size="large" className="landing-nav">
          <a href="#how-it-works">How It Works</a>
          <a href="#pricing">Pricing</a>
          <a href="#reviews">Reviews</a>
          <Link to="/login">Sign In</Link>
          <Button type="primary" onClick={() => navigate("/register")}>
            Get Started Free
          </Button>
        </Space>
      </header>

      <section className="landing-hero">
        <Tag color="blue" className="landing-eyebrow">
          <Zap size={14} /> Join 2,500+ salons growing 40% faster with Hairplane
        </Tag>

        <Title className="landing-title">
          Run Your Salon Like a
          <span> Million-Dollar Business</span>
        </Title>

        <Paragraph className="landing-subtitle">
          Hairplane helps you manage scheduling, payments, clients, staff,
          reporting, and daily operations from one clean platform.
        </Paragraph>

        <Space size="middle" wrap className="landing-cta-row">
          <Button
            type="primary"
            size="large"
            className="landing-primary-button"
            onClick={() => navigate("/register")}
          >
            Start Free 14-Day Trial <ArrowRight size={18} />
          </Button>

          <Button size="large" onClick={() => navigate("/demo")}>
            See It In Action
          </Button>
        </Space>

        <Space wrap className="landing-checks">
          <Text><Check size={16} /> No credit card required</Text>
          <Text><Check size={16} /> Setup in minutes</Text>
          <Text><Check size={16} /> Cancel anytime</Text>
        </Space>

        <div className="landing-stats">
          {stats.map((item) => {
            const Icon = item.icon;

            return (
              <div className="landing-stat-col" key={item.label}>
                <Card className="landing-stat-card">
                  <Icon size={28} />
                  <Title level={3}>{item.stat}</Title>
                  <Text>{item.label}</Text>
                </Card>
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
}

